import { render, staticRenderFns } from "./CompEcommerceCouponDetail.vue?vue&type=template&id=5da05586"
import script from "./CompEcommerceCouponDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CompEcommerceCouponDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports